module.exports = __webpack_public_path__ + "static/media/icon_group.bcbf53f6.png";